import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ContentBody from "./ContentBody";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Organization() {
  const [leden, setLeden] = useState([]);
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch(`${API}/organizations`)
      .then(r => r.json())
      .then(data => setLeden(Array.isArray(data) ? data : []))
      .catch(console.error)
      .finally(() => setLoading(false));
    fetch(`${API}/api/content/over-ons`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data) setContent(data); })
      .catch(() => {});
  }, []);

  if (loading) return <div className="pane"><p>Laden…</p></div>;

  return (
    <div className="pane">
      <h1>{content ? content.title : "Leden"}</h1>
      <ContentBody data={content} />

      {leden.length === 0 && <p>Nog geen leden geregistreerd.</p>}

      <div className="org-list">
        {leden.map(lid => {
          const athlete = lid.athleteId;
          // don't show nickname here
          const displayName = athlete
            ? (athlete.name || `${athlete.firstName} ${athlete.lastName}`)
            : lid.name;

          return (
            <div key={lid._id} className="org-card">
              {athlete?.profilePhoto && (
                <img
                  src={athlete.profilePhoto}
                  alt={athlete.firstName}
                  className="org-card-photo"
                />
              )}

              <div className="org-card-header">
                <h2 className="org-card-name">{displayName}</h2>
                {lid.tags?.length > 0 && (
                  <p className="org-card-tags">
                    {lid.tags.join(" • ")}
                  </p>
                )}
                {athlete && (
                  <Link to={`/athletes/${athlete._id}`} className="org-card-link">
                    Bekijk activiteiten
                  </Link>
                )}
              </div>

              {lid.story && (
                <>
                  <hr className="org-card-divider" />
                  {lid.story.split("\n").filter(Boolean).map((line, i) => (
                    <p key={i} className="org-card-story">{line}</p>
                  ))}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
